import ArchivedSelect from './_ArchivedSelect';

export default ArchivedSelect;
